module.exports = __webpack_public_path__ + "static/media/71nULqACDeL._AC_SY550._SX._UX._SY._UY_.2c09c24f.jpg";